import { Link, useRouter } from "@tanstack/react-router";
import { ArrowLeft, FileQuestion, Home } from "lucide-react";
import { Button, buttonVariants } from "@/components/ui/button";
import { StatusPanel } from "@/components/ui/status-panel";

/**
 * Global 404 page for unknown routes (e.g., /settings, /random, /dashboard).
 *
 * Rendered by TanStack Router's `notFoundComponent` on the root route.
 * Appears inside the authenticated app shell (header visible).
 */
export function GlobalNotFound() {
  const router = useRouter();

  return (
    <StatusPanel
      icon={FileQuestion}
      eyebrow="404"
      title="Page not found"
      description="The page you're looking for doesn't exist or has been moved."
      tone="info"
      size="page"
      className="flex-1"
      actions={
        <>
          <Button variant="outline" size="lg" onClick={() => router.history.back()}>
            <ArrowLeft data-icon="inline-start" />
            Go Back
          </Button>
          <Link to="/" className={buttonVariants({ size: "lg" })}>
            <Home data-icon="inline-start" />
            Home
          </Link>
        </>
      }
    />
  );
}
